import axios from "axios";
import { toast } from "react-hot-toast";
import API_BASE_URL from "../config/config.js";

export const randomSembradoEspecialFutbolDamas = async (idevent, idsport) => {
  try {
    const ideventValue = Number(idevent);
    const idsportValue = Number(idsport);

    // Definir las regiones directamente
    const regions = [
      { idregion: 1, name: "Lima", total: 2, heads: 1 },
      { idregion: 2, name: "Sur", total: 6, heads: 1 },
      { idregion: 3, name: "Norte", total: 1, heads: 0 },
      { idregion: 4, name: "Centro", total: 1, heads: 0 },
    ];

    const regionsCopy = JSON.parse(JSON.stringify(regions)); // Copia profunda para manipulación

    console.log("info regions", regionsCopy); // Verificar la copia

    // Definir los grupos A y B con los participantes especificados
    const groups = [
      {
        idgroup: 1, // Grupo A
        participants: [],
        maxParticipants: 5, // Tamaño máximo de grupo (5)
      },
      {
        idgroup: 2, // Grupo B
        participants: [],
        maxParticipants: 5, // Tamaño máximo de grupo (5)
      },
    ];

    // Función para mezclar un array aleatoriamente
    const shuffleArray = (array) => {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    };

    // Función para asignar un participante a un grupo
    const assignParticipantToGroup = (region, group, nro_grupo) => {
      if (
        group.participants.length >= group.maxParticipants ||
        region.total <= 0
      ) {
        return; // Verificar límite de participantes y si quedan participantes
      }
      group.participants.push({
        idevent: ideventValue,
        idsport: idsportValue,
        idgroup: group.idgroup,
        nro_grupo, // Asegurar que sea único dentro del grupo
        idregion: region.idregion,
      });
      region.total--; // Reducir el total de participantes restantes en esa región
    };

    // Distribuir participantes según el caso específico con aleatoriedad
    const distributeParticipants = () => {
      const limaRegion = regionsCopy.find((r) => r.name === "Lima");
      const surRegion = regionsCopy.find((r) => r.name === "Sur");
      const norteRegion = regionsCopy.find((r) => r.name === "Norte");
      const centroRegion = regionsCopy.find((r) => r.name === "Centro");

      // Aleatorizar cuál es la cabeza de grupo para Grupo A y Grupo B
      const [groupAHead, groupBHead] = shuffleArray([limaRegion, surRegion]);

      // 1. Asignar cabezas de grupo: Lima en uno y Sur en otro en nro_grupo 1
      assignParticipantToGroup(groupAHead, groups[0], 1); // Asignar cabeza a Grupo A en nro_grupo 1
      assignParticipantToGroup(groupBHead, groups[1], 1); // Asignar cabeza a Grupo B en nro_grupo 1

      // 2. Distribuir los participantes de "Sur" de manera aleatoria, asegurando 3 en cada grupo
      for (let i = 0; i < 3; i++) {
        assignParticipantToGroup(surRegion, groups[0], i + 2); // Sur en Grupo A
        assignParticipantToGroup(surRegion, groups[1], i + 2); // Sur en Grupo B
      }

      // 3. Asignar el segundo participante de Lima al grupo que le falte
      if (groupAHead === limaRegion) {
        assignParticipantToGroup(limaRegion, groups[1], 2); // Segundo Lima en Grupo B
      } else {
        assignParticipantToGroup(limaRegion, groups[0], 2); // Segundo Lima en Grupo A
      }

      // 4. Asignar "Norte" y "Centro" de manera aleatoria a los dos grupos
      const remainingRegions = shuffleArray([norteRegion, centroRegion]); // Aleatorizar orden
      assignParticipantToGroup(remainingRegions[0], groups[0], 5); // Asignar al Grupo A
      assignParticipantToGroup(remainingRegions[1], groups[1], 5); // Asignar al Grupo B
    };

    // Distribuir los participantes
    distributeParticipants();

    // Mezclar la posición de los participantes en cada grupo aleatoriamente
    groups.forEach((group) => {
      group.participants = shuffleArray(group.participants).map(
        (participant, index) => ({
          ...participant,
          nro_grupo: index + 1, // Asignar el número de grupo aleatorio después de mezclar
        })
      );
    });

    // Verificar si queda algún participante sin asignar
    const allParticipantsAssigned = regionsCopy.every(
      (region) => region.total === 0
    );

    if (!allParticipantsAssigned) {
      console.error(
        "Error: La distribución no generó el número correcto de participantes."
      );
      console.log(
        "Estado de regionsCopy después de distribución:",
        regionsCopy
      ); // Imprimir estado después de distribución
      return;
    }

    // Construir el arreglo final para enviar al backend
    const groupSembrado = groups.flatMap((group) => group.participants);
    const totalParticipants = 10; // Sumar 2 (Lima) + 6 (Sur) + 1 (Norte) + 1 (Centro) = 10

    // Verificar que el total de elementos sea correcto
    if (groupSembrado.length !== totalParticipants) {
      console.error(
        "Error: La distribución no generó el número correcto de participantes."
      );
      console.log("Participantes generados:", groupSembrado); // Mostrar participantes generados
      return;
    }

    // Enviar los datos al endpoint
    console.log("Información del Sembrado", groupSembrado);
    await axios.post(`${API_BASE_URL}/postsembrado`, groupSembrado);

    toast.success("¡Sembrado generado exitosamente!");
  } catch (error) {
    toast.error("¡Error al generar sembrado!");
    console.error("Error al generar sembrado", error);
  }
};
